import { GET_DASHBOARD_INFO } from '../constants';

export function getDashboardInfo(resolve: any, reject: any) {
  return {
    type: GET_DASHBOARD_INFO,
    resolve,
    reject
  };
}
